import clsx from 'clsx';
import { LuChevronLeft } from 'react-icons/lu';
import { RoundButton, RoundButtonProps } from './RoundButton';

export const RoundPrevButton = ({
  size = 'md',
  ...props
}: RoundButtonProps) => (
  <RoundButton size={size} {...props}>
    <LuChevronLeft
      className={clsx(
        size === 'sm' && 'text-4xl',
        size === 'md' && 'text-6xl',
        size === 'lg' && 'text-8xl',
      )}
    />
  </RoundButton>
);
